module.exports = __webpack_public_path__ + "img/unknown.8ad3023c.png";